import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * user clicks the box to agree to terms and conditions.
 */
const logCheckoutTermsandConditionsChecked = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('checkout termsand conditions checked', {}, callback);
};

export default logCheckoutTermsandConditionsChecked;
